import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const FormEditionStore = lazy(() =>
  import('src/pages/form/FormEdition').then((module) => ({ default: module.FormEditionStore }))
);
const FormViewStore = lazy(() =>
  import('src/pages/form/FormView').then((module) => ({ default: module.FormViewStore }))
);
const FormFillingOutStore = lazy(() =>
  import('src/pages/form/FormFillingOut').then((module) => ({
    default: module.FormFillingOutStore,
  }))
);


const FormResultsStore = lazy(() =>
  import('src/pages/form/FormResults').then((module) => ({
    default: module.FormResultsStore,
  }))
);

const FormByParticipant = lazy(() => import('src/pages/form/FormByParticipant'));
const ParticipantByForm = lazy(() => import('src/pages/form/ParticipantByForm'));
const FormList = lazy(() => import('src/pages/form/FormList'));
const OrderListView = lazy(() => import('src/components/form/dataTables/sessions'));

// ----------------------------------------------------------------------

export const formOrganizationRoutes = [
  {
    path: 'forms',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <FormList />, index: true },
      { path: 'edition', element: <FormEditionStore /> },
      { path: ':id/participant/:traineeid/results', element: <FormResultsStore /> },
      { path: 'participant', element: <FormByParticipant /> },
      { path: ':id/:participant', element: <ParticipantByForm /> },
    ],
  },
  {
    path: 'forms/view',
    element: (
      <FormLayout>
        <Suspense fallback={<LoadingScreen />}>
          <FormFillingOutStore preview />
        </Suspense>
      </FormLayout>
    ),
  },
  {
    path: 'forms/test',
    element: (
      <FormLayout>
        <Suspense fallback={<LoadingScreen />}>
          <OrderListView />
        </Suspense>
      </FormLayout>
    ),
  },
  {
    path: '/forms/:id/filled/:participant',
    element: (
      <FormLayout>
        <Suspense fallback={<LoadingScreen />}>
          <FormFillingOutStore />
        </Suspense>
      </FormLayout>
    ),
  },
];

export const formParticipantRoutes = [
  {
    path: 'trainees/forms',
    element: (
      <AuthGuard allowedRoles={['trainee']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <FormByParticipant />, index: true },
      { path: ':id/results', element: <FormResultsStore /> },
    ],
  },
  {
    path: 'forms/:id/filled/:participant',
    element: (
      <FormLayout>
        <Suspense fallback={<LoadingScreen />}>
          <FormFillingOutStore />
        </Suspense>
      </FormLayout>
    ),
  },
];
